import * as Yup from 'yup'

// Password validation function used in multiple schemas
// Ensures the password is required, between 8 and 16 characters
export const passwordValidation = () => {
  return Yup.string()
    .required(`Password is required`)
    .min(8, `Password must be at least 8 characters`)
    .max(16, `Password must be at most 16 characters`)
}

// Validation schema for the Login form
export const loginSchema = Yup.object({
  id: Yup.string().notRequired(), // Optional user ID field
  email: Yup.string()
    .email('Invalid email address') // Must be a valid email format
    .required('Email is required'), // Email is required
  password: Yup.string().required('Password is required'), // Password is required
})

// Validation schema for the Forgot Password form
export const forgotPasswordSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address') // Must be a valid email format
    .required('Email is required'), // Email is required
})

// Validation schema for Reset Password (admin reset or via token)
export const resetPasswordSchema = Yup.object().shape({
  id: Yup.string().notRequired(), // Optional user ID
  new_password: passwordValidation(), // Reuse password validation logic
  confirm_new_password: Yup.string()
    .required('Confirm password is required') // Confirm field is required
    .oneOf([Yup.ref('new_password')], 'Passwords must match'), // Must match new_password field
})

// Validation schema for authenticated user changing their own password
export const resetAuthPasswordSchema = Yup.object().shape({
  password: Yup.string().required('Old password is required'), // Current password is required
  new_password: passwordValidation().notOneOf(
    [Yup.ref('password')],
    'New password must be different from the current password',
  ), // New password must differ from old password
  confirm_new_password: Yup.string()
    .required('Confirm password is required') // Confirm field is required
    .oneOf([Yup.ref('new_password')], 'Passwords must match'), // Must match new_password field
})
